<script>
    import { getBaseUrl } from "../utils";
    import  clientService from "../services/clients.js";

    export default {
        name: "widget-client-info",
        data() {
            return {
                client: null
            };
        },
        methods: {
            goTo(option) {
                let url = getBaseUrl();
                switch (option) {
                    case "cts":
                        url = `${url}/contagem/?codigo=${this.client.id}`;
                        break;
                    case "rmi":
                        url = `${url}/rmi/?codigo=${this.client.id}`;
                        break;
                    case "evolucao":
                        url = `${url}/evolucao/?codigo=${this.client.id}&type=evolucao`;
                        break;
                    case "inicial":
                        url = `${url}/evolucao/?codigo=${this.client.id}&type=inicial`;
                        break;
                    case "liquidacao":
                        url = `${url}/evolucao/?codigo=${this.client.id}&type=liquidacao`;
                        break;
                    case "revisao":
                        url = `${url}/revisao/?codigo=${this.client.id}`;
                        break;
                }
                    window.open(url, "_blank");
            },

            deleteClient() {
                clientService.remove(this.client.id).then( res => {
                    // console.log(res);
                    this.removeCliente();

                }).catch(err => {
                    // console.log(err)
                })
            },
            removeCliente() {
                this.$store.commit("CLIENTS_REMOVE_CLIENT",  this.client);
                this.$store.commit("CLIENTS_SET_SELECTED", { client: false });
                this.client = false;
            },
            confirmDelete() {
                this.$bus.$emit("confirModal", {
                    confirmOnly: false,
                    title: this.client.nome,
                    message: `<b>Deseja realmente deletar este cliente?</b></br></br>
                    Todos os dados do cliente juntamente com os cálculos salvos serão <b>permanentemente</b> deletados`,
                    responseKey: "deleteClient"
                });
            }
        },

        created: function() {
            this.$bus.$on("showClient", data => {
                (this.client = data),
                this.$store.commit("CLIENTS_SET_SELECTED", { client: this.client });
            });

            this.$bus.$on("deleteClient", yes => {
                yes ?
                this.deleteClient():'';

            })
        },
        computed : {
            observacao : function() {
                const obs = this.client.observacao;
                return obs ? obs.length > 30 ?
                            obs.substring(0,30) + " ..." :
                            obs : " - ";
            }
        }
    };
</script>
<template>
<div class="client-pre-info" v-if="client">
   <ul class="info">
      <li class="item name text-secondary-color">{{client.nome}}</li>
      <li class="item phone"><span>Telefone:</span> {{client.fone1 ? client.fone1 : ' -'}}</li>
      <li class="item phone"><span>Celular:</span> {{client.fone2 ? client.fone2 : ' -'}}</li>
      <li class="item email"><span>Email:</span> {{client.email ? client.email : ' -'}}</li>
      <li class="item cpf"><span>CPF:</span> {{client.cpf ? client.cpf : ' -'}}</li>
      <li class="item rg"><span>RG: </span> {{client.rg ? client.rg : ' -'}}</li>
      <li class="item dob" v-if="!client.dtNascimento"><span>Nascimento: </span>-</li>
      <li class="item dob" v-if="client.dtNascimento"><span>Nascimento: </span> {{client.dtNascimento | moment("DD/MM/YYYY")}}</li>
      <li class="item gender"><span>Sexo:</span> {{client.sexo ? client.sexo : '-'}}</li>
      <li class="item more"><span>Obs:</span> {{ observacao }}</li>
    <button title="Deletar Cliente" @click.prevent="confirmDelete()" class="btn-delete btn-icon-sm btn-action">
        <i class="p-icon"><svg class="icon warn-stroke --hover"><use xlink:href="#sprite-delete"/></svg></i>
    </button>
    <a :href="`editar-clientes.php?id=${client.id}`" title="Atualizar Cliente" class="d-block btn-icon btn-icon-sm btn-action btn-update">
        <i class="p-icon"><svg class="icon primary-fill --hover"><use xlink:href="#sprite-update"/></svg></i>
    </a>
   </ul>
    <hr class="separator mb-0">
    <div class="actions">
      <!-- <a href="#" class="action py-2 px-3 w-100 d-flex align-items-center">
         <i class="p-icon rouded mr-1">
            <svg class="icon secondary-stroke"><use xlink:href="#sprite-more"/></svg>
         </i>
         <span>Adicionar Cálculo Previdenciário</span>
      </a> -->

      <a href="#" @click.prevent="goTo('cts')" class="grey lighten-3 action py-2 px-3 w-100 d-flex align-items-center">
         <i class="p-icon rouded mr-1">
            <!-- <svg class="icon secondary-stroke"><use xlink:href="#sprite-table"/></svg> -->
            <i class="far fa-calendar-alt icon"></i>
         </i>
         <span>Cálculo do tempo de contribuição</span>
         <i class="p-icon rouded ml-auto">
            <svg class="icon secondary-fill"><use xlink:href="#sprite-right_rounded"/></svg>
         </i>
      </a>
      <a href="#" @click.prevent="goTo('rmi')" class="grey lighten-3 action py-2 px-3 w-100 d-flex align-items-center">
         <i class="p-icon rouded mr-1">
            <!-- <svg class="icon secondary-stroke"><use xlink:href="#sprite-table"/></svg> -->
            <i class="fas fa-calculator icon"></i>
         </i>
         <span>Cálculo da RMI</span>
         <i class="p-icon rouded ml-auto">
            <svg class="icon secondary-fill"><use xlink:href="#sprite-right_rounded"/></svg>
         </i>
      </a>
      <a href="#" @click.prevent="goTo('evolucao')" class="grey lighten-3 action py-2 px-3 w-100 d-flex align-items-center">
         <i class="p-icon rouded mr-1">
            <!-- <svg class="icon secondary-stroke"><use xlink:href="#sprite-table"/></svg> -->
            <i class="fas fa-dollar-sign icon"></i>
         </i>
         <span>Evolução da Renda</span>
         <i class="p-icon rouded ml-auto">
            <svg class="icon secondary-fill"><use xlink:href="#sprite-right_rounded"/></svg>
         </i>
      </a>
      <a href="#" @click.prevent="goTo('inicial')" class="grey lighten-3 action py-2 px-3 w-100 d-flex align-items-center">
         <i class="p-icon rouded mr-1">
            <!-- <svg class="icon secondary-stroke"><use xlink:href="#sprite-table"/></svg> -->
            <i class="fas fa-hand-holding-usd icon"></i>
         </i>
         <span>Valor da Causa</span>
         <i class="p-icon rouded ml-auto">
            <svg class="icon secondary-fill"><use xlink:href="#sprite-right_rounded"/></svg>
         </i>
      </a>
      <a href="#" @click.prevent="goTo('liquidacao')" class="grey lighten-3 action py-2 px-3 w-100 d-flex align-items-center">
         <i class="p-icon rouded mr-1">
            <!-- <svg class="icon secondary-stroke"><use xlink:href="#sprite-table"/></svg> -->
            <i class="fas fa-file-invoice-dollar icon"></i>
         </i>
         <span>Liquidação de Sentença</span>
         <i class="p-icon rouded ml-auto">
            <svg class="icon secondary-fill"><use xlink:href="#sprite-right_rounded"/></svg>
         </i>
      </a>
      <a href="#" @click.prevent="goTo('revisao')" class="grey lighten-3 action py-2 px-3 w-100 d-flex align-items-center">
         <i class="p-icon rouded mr-1">
            <!-- <svg class="icon secondary-stroke"><use xlink:href="#sprite-table"/></svg> -->
            <i class="fas fa-clipboard-check icon"></i>
         </i>
         <span>Revisão</span>
         <i class="p-icon rouded ml-auto">
            <svg class="icon secondary-fill"><use xlink:href="#sprite-right_rounded"/></svg>
         </i>
      </a>

   </div>
</div>
<div class="client-pre-info" v-else>
   <div class="info">
      <p>Esta é sua pagina de clientes<br>
      Clique em um cliente para ver detalhes e observaçoes.<br><br>
      Para adicionar um novo <b>cliente</b>, clique no botão <span class="text-primary-color">Novo Cliente</span> acima
      <br><br>
      Ao selecionar um Cliente, serão exibidas as opções de cálculos.</p>
   </div>
</div>
</template>
<style lang="scss" scoped>
.client-pre-info {
    .info {
        position: relative;
        padding: 15px 15px 0;
        width: 100%;

        .item {
            font-size: 12px;
            span {
                color: #9c9c9c;
                position: relative;
                padding: 10px 0;
                vertical-align: middle;
                text-transform: uppercase;
                font-size: 11px;
            }

            &.name {
                font-weight: bold;
            }
        }
        > .btn-delete {
            position: absolute;
            right: 16px;
            bottom: 0;
        }

        > .btn-update {
            position: absolute;
            right: 40px;
            bottom: 0;

        }
    }

    > .actions {
        .action {
            font-size: 0.8rem;

            &:not(:last-of-type) {
                border-bottom: 1px solid #e0e0e0;
            }
        }
        .p-icon {
            width: 20px;
            height: 20px;
        }
        .icon {
            width: 12px;
            height: 12px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/js/components/widget-client-info.vue